"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var spaui_utils_1 = require("@tencent/spaui-utils");

var info_1 = __importDefault(require("./info"));

var spaui_1 = require("@tencent/spaui");

var MetaFormGroup = function MetaFormGroup(props) {
  var feedback = props.feedback,
      feedbackSpace = props.feedbackSpace,
      _a = props.feedbackClassName,
      feedbackClassName = _a === void 0 ? '' : _a,
      helpTips = props.helpTips,
      helpBlock = props.helpBlock,
      helpBlockClassName = props.helpBlockClassName,
      children = props.children,
      _b = props.className,
      className = _b === void 0 ? '' : _b,
      error = props.error,
      addons = props.addons,
      status = props.status,
      prefix = props.prefix,
      clear = props.clear,
      onClear = props.onClear,
      _c = props.legacy,
      legacy = _c === void 0 ? false : _c,
      _d = props.classNameMap,
      classNameMap = _d === void 0 ? {} : _d,
      _e = props.style,
      formGroupStyle = _e === void 0 ? {} : _e,
      wrapStyle = props.wrapStyle,
      formGroupProps = props.formGroupProps;
  return react_1["default"].createElement("div", __assign({}, (0, spaui_utils_1.globalProps)(props, {
    className: 'meta-form-item',
    supportAllEvents: true,
    style: wrapStyle
  }, MetaFormGroup)), react_1["default"].createElement(spaui_1.FormGroup, __assign({
    feedback: feedback,
    className: (0, classnames_1["default"])(typeof classNameMap.MetaFormGroup === 'undefined' ? "meta-form-group".concat(legacy ? ' meta-form-group-legacy' : '') : classNameMap.MetaFormGroup, className),
    feedbackClassName: feedbackClassName,
    feedbackSpace: feedbackSpace,
    // error 优先级最高，没 error 显示 helpBlock（支持status）
    error: error,
    status: status,
    helpBlock: helpBlock,
    helpBlockClassName: helpBlockClassName,
    clear: clear,
    onClear: onClear,
    style: formGroupStyle,
    prefix: prefix
  }, formGroupProps), children), helpTips ? react_1["default"].createElement("div", {
    className: "meta-help-tips"
  }, react_1["default"].createElement("div", {
    className: "meta-help-tips-inner"
  }, helpTips)) : null, addons);
};

(0, spaui_utils_1.setComponentMark)(MetaFormGroup, info_1["default"]);
exports["default"] = react_1["default"].memo(MetaFormGroup);